// Zahlen- und Betragsformat der Oberfläche in der Sprache der Seite: das Format
// kommt aus PHP (I18n::amountFormat) als data-amount-format.

/** 1234.5 → "1.234,50" (de-DE) oder "1,234.50" (en-GB) */
export function twoDecimals(value, locale) {
  return value.toLocaleString(locale || 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Betrag in Dollar: "0,15 $" oder "$0.15". */
export function usd(value, format) {
  return (format.prefix || '') + twoDecimals(value, format.locale) + format.unit;
}

/**
 * Geschätzter Betrag im Format aus I18n::amountFormat, das die Seite als
 * data-amount-format mitgibt - dieselbe Darstellung wie der Twig-Filter amount:
 * null ist exakt (z. B. SerpApi Free Plan), unter der Schwelle eine Schranke,
 * alles andere eine Schätzung.
 */
export function amount(value, format) {
  if (value === 0) return format.zero;
  return value < format.min ? format.below : format.approx + usd(value, format);
}
